import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;

export default axios;


//////////////////
// WEBPACK FOOTER
// ./config/axios.js
// module id = null
// module chunks = 